import { useQuery } from "@tanstack/react-query";
import { getMoeLoginUrl } from "@/apis/oneclubMoe/services/users";

export const useGetMoeLoginUrlQuery = () => {
  return useQuery({
    queryKey: ["oneclubMoe", "getMoeLoginUrl"],
    queryFn: getMoeLoginUrl,
  });
};
